import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { Teaser } from 'b2b-components/theme/components/CMS/Teaser';
import { VideoTeaser } from 'b2b-components/theme/components/CMS/VideoTeaser';
import { Slider } from 'b2b-components/theme/components/Slider';
import { createKey } from 'b2b-apps/shop/common/utils/key/key';
import { BannerSlideProps, ComponentType, Props } from './';

const GAP_BETWEEN_SLIDES = 16;
const SLIDER_AUTOPLAY_DELAY = 5000;

const Banner: ComponentType = ({
  className,
  slidesProps,
  hasSlider,
}: Props): ReactElement | null => {
  const bannerSlides: ReactElement[] = slidesProps.map(
    (props: BannerSlideProps): ReactElement => {
      const Component = props.videoUrl ? VideoTeaser : Teaser;

      return (
        <Component
          buttonLabel={props.buttonLabel}
          content={props.content}
          contentPosition={props.contentPosition}
          imagePosition={props.imagePosition}
          imageUrl={props.imageUrl}
          logoPosition={props.logoPosition}
          logoUrl={props.logoUrl}
          onClick={props.onClick}
          styleType={props.styleType}
          title={props.title}
          text={props.text}
          type={props.type}
          url={props.url}
          videoUrl={props.videoUrl}
          key={createKey('banner', props.type, props.imageUrl)}
        />
      );
    },
  );

  return (
    <div className={classNames('cds-cms-GridRow', className)}>
      {hasSlider ? (
        <div className="cds-cms-BannerContainer">
          <Slider
            autoplayDelay={SLIDER_AUTOPLAY_DELAY}
            isPagination={true}
            spaceBetween={GAP_BETWEEN_SLIDES}
          >
            {bannerSlides}
          </Slider>
        </div>
      ) : (
        <div className="cds-cms-BannerContainer">
          <div className="cds-cms-GridRow">{bannerSlides}</div>
        </div>
      )}
    </div>
  );
};

export { Banner };
